import { Link } from 'react-router-dom';
import { getWeeklyActive } from '@/lib/community';
import { formatCount, cn } from '@/lib/format';
import UserAvatar from '@/components/feature/UserAvatar';

const activeUsers = getWeeklyActive();

const rankStyle = ['bg-primary-500 text-background-50', 'bg-accent-500 text-background-50', 'bg-secondary-500 text-background-50'];

export default function ActiveUsers() {
  return (
    <section className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
          <i className="ri-trophy-line text-lg" />
        </span>
        <div>
          <h2 className="text-base font-extrabold text-foreground-900">本周活跃用户</h2>
          <p className="text-xs text-foreground-400">发帖与互动榜单</p>
        </div>
      </div>

      <ol className="flex flex-col gap-1">
        {activeUsers.map((item, idx) => (
          <li key={item.user.id}>
            <Link
              to={`/user/${item.user.id}`}
              className="flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className={cn('w-6 h-6 rounded-md text-xs font-label font-extrabold flex items-center justify-center shrink-0', idx < 3 ? rankStyle[idx] : 'bg-background-200 text-foreground-600')}>
                {idx + 1}
              </span>
              <UserAvatar src={item.user.avatar} alt={item.user.name} size="sm" />
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-bold text-foreground-900 truncate">{item.user.name}</span>
                <span className="block text-[11px] text-foreground-400 truncate">{item.user.badges[0]}</span>
              </span>
              <span className="text-right shrink-0">
                <span className="block text-xs font-label font-bold text-primary-700">{item.weeklyPosts} 帖</span>
                <span className="block text-[11px] text-foreground-400">{formatCount(item.weeklyReplies)} 回复</span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}